import React from 'react';
import { observer } from 'mobx-react';
import { Catcher, LoadingApiByTypeAndUnit } from '../';
import { UnitTypeValues } from '../../middleware';
import { MarkersCountryTraffic, OverlayView, PolygonsCountryTraffic } from './Components';
import BaseMap from './Components/BaseMap';
import Styles from './m_googleMapsStyles.less';

export const GoogleTrafficMap: React.FC = observer(function Map() {
    return (
        <Catcher>
            <div className={Styles.googleTrafficMap}>
                <LoadingApiByTypeAndUnit apiTypeId={`GET_USAGE_COUNTRY_LIST`} unitType={UnitTypeValues.DATA} />
                <BaseMap zoom={2}>
                    <MarkersCountryTraffic />
                    <PolygonsCountryTraffic />
                    <OverlayView />
                </BaseMap>
            </div>
        </Catcher>
    );
});
